/* HCORZ
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 11/07/2025 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import { ConfiguracionProvider } from "./ConfiguracionContext";
import { LayoutProvider } from "./LayoutContext";
import { SesionProvider } from "./SesionContext";
import { TimeSetExecutionProvider } from "./TimeSetExecutionContext"

export const AllSystemProvider = (props) => (
  <ConfiguracionProvider>
    <LayoutProvider>
      <SesionProvider>
        <TimeSetExecutionProvider>
          {props.children}
        </TimeSetExecutionProvider>
      </SesionProvider>
    </LayoutProvider>
  </ConfiguracionProvider>
);
